var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { RequestOptions, XHRBackend } from "@angular/http";
import { ProgressBrowserXhrFactory } from "./ProgressBrowserXhrFactory";
import { XHRBackendFactory } from "./XHRBackendFactory";
import { ProgressHttp } from "./progress-http.service";
import { HTTP_FACTORY } from "./http-factory.token";
import { AngularHttpFactory } from "./AngularHttpFactory";
export function progressHttpFactory(xhrBackendFactory, backend, requestOptions, httpFactory) {
    return new ProgressHttp(xhrBackendFactory, requestOptions, httpFactory, backend);
}
var ProgressHttpModule = (function () {
    function ProgressHttpModule() {
    }
    return ProgressHttpModule;
}());
ProgressHttpModule = __decorate([
    NgModule({
        providers: [
            ProgressBrowserXhrFactory,
            XHRBackendFactory,
            AngularHttpFactory,
            { provide: HTTP_FACTORY, useClass: AngularHttpFactory },
            {
                provide: ProgressHttp,
                useFactory: progressHttpFactory,
                deps: [XHRBackendFactory, XHRBackend, RequestOptions, HTTP_FACTORY]
            },
        ]
    })
], ProgressHttpModule);
export { ProgressHttpModule };
//# sourceMappingURL=progress-http.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/progress-http.module.js
// module id = 864
// module chunks = 3